var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRolesImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    enableBackground: "new 0 0 80 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4E8BC9",
    d: "M69.784,38.966v20.06H29.778l-9.747,9.747v-9.747H10V19.306h20.063v-0.217H70 M21.637,64.9l6.945-6.951 l0.531-0.526H68.18V20.91H11.604v36.513h10.033V64.9z M68.396,20.695H31.667v-1.39h38.117v18.055"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.032,
    y: 38.364,
    fill: "#4E8BC9",
    width: 39.722,
    height: 1.604
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.032,
    y: 48.395,
    fill: "#4E8BC9",
    width: 19.359,
    height: 1.604
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.032,
    y: 28.333,
    fill: "#4E8BC9",
    width: 39.722,
    height: 1.606
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesImage);
export default __webpack_public_path__ + "static/media/rolesImage.13467aecf15e47f0e5945ab26ad3b572.svg";
export { ForwardRef as ReactComponent };